/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/promise-function-async */
// گزارش براساس خروجی اکسل

import AssessmentIcon from '@mui/icons-material/Assessment'
import { Fab, Tooltip } from '@mui/material'
import Excel from 'exceljs'
import { saveAs } from 'file-saver'
import React, { FC } from 'react'

interface Props {
  excelData: any
  // fileName: string
  titlle: string
  date: string
}
const columns: any = [
  { header: 'ردیف', key: 'ردیف' },
  { header: 'شرکت سازنده', key: 'شرکت سازنده' },
  { header: 'نوع خودرو', key: 'نوع خودرو' },
  { header: 'شماره پلاک', key: 'شماره پلاک' },
  { header: 'نام و نام خانوادگی', key: 'نام و نام خانوادگی' },
  { header: 'شماره همراه کاربر', key: 'شماره همراه کاربر' },
  { header: 'شماره شناسایی دستگاه', key: 'شماره شناسایی دستگاه' },
  { header: 'شماره سیم کارت', key: 'شماره سیم کارت' },
  { header: 'ورژن نرم افزار دستگاه', key: 'ورژن نرم افزار دستگاه' },
  { header: 'آخرین ارتباط', key: 'آخرین ارتباط' },
  { header: 'آخرین موقعیت جغرافیایی', key: 'آخرین موقعیت جغرافیایی' },
  { header: 'وضعیت دستگاه', key: 'وضعیت دستگاه' }
]

const ExcelJsExport: FC<Props> = ({ excelData, titlle, date }) => {
  const workSheetName = 'Worksheet-1'
  const exportToExcel = async () => {
    const workbook = new Excel.Workbook()
    const fileName = 'NajiHooshmand'
    const worksheet = workbook.addWorksheet(workSheetName)
    worksheet.columns = columns
    worksheet.getRow(1).font = { bold: true }
    worksheet.insertRow(1, [titlle])
    worksheet.insertRow(2, [date])
    worksheet.mergeCells('A1:L1')
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' }
    worksheet.mergeCells('A2:L2')
    worksheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
    worksheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F08080' },
    }
    worksheet.getCell('A2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'c1c0c1' },
    }

    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' }
    worksheet.columns.forEach((column) => {
      if (column.header !== undefined) column.width = column.header.length + 5
      column.alignment = { horizontal: 'center' }
    })
    excelData.forEach((singleData: any) => {
      worksheet.addRow(singleData)
    })
    const borderStyles = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }

    worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function (cell: any, colNumber) {
        cell.border = borderStyles
      })
    })

    worksheet.headerFooter.firstFooter = 'Naji Hooshmand Company'
    const buf = await workbook.xlsx.writeBuffer()
    saveAs(new Blob([buf]), `${fileName}.xlsx`)
  }

  return (
    <>
      <Fab aria-label='edit' color='error' onClick={exportToExcel} size='small' sx={{ mr: 0.5 }}>
        <AssessmentIcon />
      </Fab>
    </>
  )
}

export default ExcelJsExport
